module.exports = __webpack_public_path__ + "static/assets/loader.35ce7631.gif";